/**
 * Profanity Filter - Simple word list checker for usernames
 */

const PROFANE_WORDS = [
  'fuck',
  'shit',
  'ass',
  'bitch',
  'damn',
  'dick',
  'cock',
  'cunt',
  'pussy',
  'bastard',
  'slut',
  'whore',
  'fag',
  'nigga',
  'nigger',
  'retard',
  'rape',
  'nazi',
  'hitler',
  'porn',
  'sex',
  'xxx',
  'anal',
  'cum',
  'jizz',
  'piss',
  'wank',
  'tit',
  'boob',
  'dildo',
  'viagra',
  'penis',
  'vagina',
  'testicle',
  'scrotum',
  'anus',
  'feces',
  'poop',
  'urine',
];

/**
 * Check if a username contains profanity
 * Checks for exact words and common variations (leet speak, etc.)
 */
export function containsProfanity(text: string): boolean {
  if (!text) return false;

  const normalized = text.toLowerCase()
    .replace(/[^a-z0-9]/g, '') // Remove special chars
    .replace(/0/g, 'o')
    .replace(/1/g, 'i')
    .replace(/3/g, 'e')
    .replace(/4/g, 'a')
    .replace(/5/g, 's')
    .replace(/7/g, 't')
    .replace(/8/g, 'b');

  return PROFANE_WORDS.some(word => {
    // Check if the profane word is in the normalized text
    return normalized.includes(word);
  });
}

/**
 * Validate username for profanity and return error message if found
 */
export function validateUsername(username: string): string | null {
  if (!username) return 'Username is required';

  if (username.length < 3) {
    return 'Username must be at least 3 characters';
  }

  if (!/^[a-zA-Z0-9_-]+$/.test(username)) {
    return 'Username can only contain letters, numbers, underscores, and hyphens';
  }

  if (containsProfanity(username)) {
    return 'Username contains inappropriate language';
  }

  return null;
}
